var bittoelatings_a = [{
        rule: "maatskappye:create",
        bitmask: "1",
        blok: 0,
        beskrywing: "Skep van maatskappye",
        groepe: ["maatskappye", "setup"],
    },
    {
        rule: "maatskappye:read",
        bitmask: "2",
        blok: 0,
        beskrywing: "Lees van maatskappye",
        groepe: ["maatskappye", "basis"],
    },
    {
        rule: "maatskappye:update",
        bitmask: "4",
        blok: 0,
        beskrywing: "Veranderinge aan maatskappye",
        groepe: ["maatskappye", "setup"],
    },
    {
        rule: "maatskappye:delete",
        bitmask: "8",
        blok: 0,
        beskrywing: "Verwydering van maatskappye",
        groepe: ["maatskappye", "setup"],
    },
    {
        rule: "seisoene:create",
        bitmask: "16",
        blok: 0,
        beskrywing: "Skep van seisoene",
        groepe: ["seisoene", "setup"],
    },
    {
        rule: "seisoene:read",
        bitmask: "32",
        blok: 0,
        beskrywing: "Lees van seisoene",
        groepe: ["seisoene", "basis"],
    },
    {
        rule: "seisoene:update",
        bitmask: "64",
        blok: 0,
        beskrywing: "Veranderinge aan seisoene",
        groepe: ["seisoene", "setup"],
    },
    {
        rule: "seisoene:delete",
        bitmask: "128",
        blok: 0,
        beskrywing: "Verwydering van seisoene",
        groepe: ["seisoene", "setup"],
    },
    {
        rule: "gewasse:create",
        bitmask: "256",
        blok: 0,
        beskrywing: "Skep van gewasse",
        groepe: ["gewasse", "setup"],
    },
    {
        rule: "gewasse:read",
        bitmask: "512",
        blok: 0,
        beskrywing: "Lees van gewasse",
        groepe: ["gewasse", "basis"],
    },
    {
        rule: "gewasse:update",
        bitmask: "1024",
        blok: 0,
        beskrywing: "Veranderinge aan gewasse",
        groepe: ["gewasse", "setup"],
    },
    {
        rule: "gewasse:delete",
        bitmask: "2048",
        blok: 0,
        beskrywing: "Verwydering van gewasse",
        groepe: ["gewasse", "setup"],
    },
    {
        rule: "kultivars:create",
        bitmask: "4096",
        blok: 0,
        beskrywing: "Skep van kultivars",
        groepe: ["kultivars", "setup"],
    },
    {
        rule: "kultivars:read",
        bitmask: "8192",
        blok: 0,
        beskrywing: "Lees van kultivars",
        groepe: ["kultivars", "basis"],
    },
    {
        rule: "kultivars:update",
        bitmask: "16384",
        blok: 0,
        beskrywing: "Veranderinge aan kultivars",
        groepe: ["kultivars", "setup"],
    },
    {
        rule: "kultivars:delete",
        bitmask: "32768",
        blok: 0,
        beskrywing: "Verwydering van kultivars",
        groepe: ["kultivars", "setup"],
    },
    {
        rule: "plase:create",
        bitmask: "65536",
        blok: 0,
        beskrywing: "Skep van plase",
        groepe: ["plase", "setup"],
    },
    {
        rule: "plase:read",
        bitmask: "131072",
        blok: 0,
        beskrywing: "Lees van plase",
        groepe: ["plase", "basis"],
    },
    {
        rule: "plase:update",
        bitmask: "262144",
        blok: 0,
        beskrywing: "Veranderinge aan plase",
        groepe: ["plase", "setup"],
    },
    {
        rule: "plase:delete",
        bitmask: "524288",
        blok: 0,
        beskrywing: "Verwydering van plase",
        groepe: ["plase", "setup"],
    },
    {
        rule: "blokke:create",
        bitmask: "1048576",
        blok: 0,
        beskrywing: "Skep van blokke",
        groepe: ["blokke", "setup"],
    },
    {
        rule: "blokke:read",
        bitmask: "2097152‬",
        blok: 0,
        beskrywing: "Lees van blokke",
        groepe: ["blokke", "basis"],
    },
    {
        rule: "blokke:update",
        bitmask: "4194304‬",
        blok: 0,
        beskrywing: "Veranderinge aan blokke",
        groepe: ["blokke", "setup"],
    },
    {
        rule: "blokke:delete",
        bitmask: "8388608‬",
        blok: 0,
        beskrywing: "Verwydering van blokke",
        groepe: ["blokke", "setup"],
    },
    {
        rule: "blokplukteiken:update",
        bitmask: "16777216‬",
        blok: 0,
        beskrywing: "Stel van 'n blok se plukteiken",
        groepe: ["blokke", "setup"],
    },
    {
        rule: "rolle:create",
        bitmask: "33554432‬",
        blok: 0,
        beskrywing: "Skep van pasgemaakte rolle",
        groepe: ["rolle", "setup"],
    },
    {
        rule: "rolle:read",
        bitmask: "67108864‬",
        blok: 0,
        beskrywing: "Lees van alle rolle",
        groepe: ["rolle", "basis"],
    },
    {
        rule: "rolle:update",
        bitmask: "134217728‬",
        blok: 0,
        beskrywing: "Veranderinge aan pasgemaakte rolle",
        groepe: ["rolle", "setup"],
    },
    {
        rule: "rolle:delete",
        bitmask: "268435456‬",
        blok: 0,
        beskrywing: "Verwydering van pasgemaakte rolle",
        groepe: ["rolle", "setup"],
    },
    {
        rule: "rolletoewys:update",
        bitmask: "536870912‬",
        blok: 0,
        beskrywing: "Toewysing van rolle",
        groepe: ["rolle", "setup"],
    },
    {
        rule: "debug:update",
        bitmask: "1073741824‬",
        blok: 0,
        beskrywing: "Toegang tot Debug-inligting",
        groepe: ["debug"],
    },
];

export default bittoelatings_a;